// vee-validate v3 skipped empty values (undefined/null/'') for non-required rules; v4 runs every
// rule regardless, so guard explicitly. NOT lodash isEmpty — that treats any number (0, 5, …) as
// empty and silently disabled these rules for numeric input.
const isEmptyValue = (value) => value === undefined || value === null || value === '';

export default {
  gte: {
    validate(value, args) {
      return value >= args.target;
    },
    params: ['target'],
    message: '{_field_} must be greater or equal than {target}',
  },
  notIn: {
    validate(value, args) {
      if (Array.isArray(value)) {
        return !value.some((v) => args.list.includes(v));
      }

      return !(args.list || []).includes(value);
    },
    params: ['list'],
    message: '{_field_} must not be in {list}',
  },
  greaterThanZero: {
    validate: (value) => {
      if (isEmptyValue(value)) {
        return true;
      }

      if (parseFloat(value) > 0) {
        return true;
      }
    },
    message: 'must be greater than 0',
  },
  greaterThanZeroOrNull: {
    validate: (value) => {
      if (isEmptyValue(value)) {
        return true;
      }

      if (parseFloat(value) > 0) {
        return true;
      }
    },
    message: 'must be greater than 0',
  },
  collectionsEmpty: {
    validate: (value, args) => {
      if (args.filter((n) => n).length === 0) {
        return true;
      }
    },
    message: 'contains errors',
  },
};
